export default __webpack_public_path__ + "static/media/whistle.996c99a6.png";